module.exports = __webpack_public_path__ + "img/icon-zoom-out.9351b0c5.svg";